import styled from '@emotion/styled'

export const Container = styled.div`
    max-width: 1310px;
    padding: 0px 15px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 10px;
    display: flex;
    flex-direction: row;

    @media (max-width: 780px) {
        flex-direction: column;
    }

    @media (max-width: 1200px) {
        width: 100%;
    }
`
